// extracted by mini-css-extract-plugin
export default {"sidenavigation":"GroupSettings_sidenavigation__1HY0i","form-width":"GroupSettings_form-width__IQsuX"};